import React, { useMemo, useEffect, useState } from 'react'
import Table from '../../../../../Components/Table/index'
import axios from 'axios'
import { useSelector } from 'react-redux'
import Spinner from 'react-bootstrap/Spinner'
import AlertMessage from '../../../../../Components/AlertMessage'
import { API_CONSTANTS } from '../../../../../API_CONSTANTS'
import Status from './Status'
import { Button, Modal } from 'react-bootstrap'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import CloseIcon from '@mui/icons-material/Close'
import PDelete from '../../../../../resources/images/svgs/Plan_Delete.svg'
import Toast from '../../../../../Components/Toast/Toast'
import {
  faCheckCircle,
  faTimesCircle,
} from '@fortawesome/fontawesome-free-solid'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ReactTagInput from '@pathofdev/react-tag-input'
import toArrayBuffer from 'to-array-buffer';

//Edit Function Component
function Edit({ responseState, UserPlanList }) {
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [isLoading, setIsLoading] = useState(false)
  const [ToastMessage, setToastMessage] = useState('')
  const [showToast, setShowToast] = useState('')
  const [ToastIcon, setToastIcon] = useState(faTimesCircle)
  const [iconColor, setIconColor] = useState('')
  const [includes, setIncludes] = useState(responseState?.includes || [])
  const [selectedSpecialization, setSelectedSpecialization] = useState("")
  const [specialization, setSpecialization] = useState(responseState?.speclization || [])
  const [planImage, setPlanImage] = useState(null)
  const [planImagePreview, setPlanImagePreview] = useState(responseState?.url || "")

  const {loading, value} = useSelector((state) => state.getDataReducer)

  // Toast Message Function 
  const handleToast = (message, icon, iconColor, className) => {
    setToastIcon(icon)
    setToastMessage(message)
    setShowToast(`show ${className}`)
    setIconColor(iconColor)
    setTimeout(() => setShowToast(''), 2900)
  }

  // Handle image upload
  const handleImageUpload = (e) => {
    const file = e.target.files[0]
    if (file) {
      setPlanImage(file)
      const reader = new FileReader()
      reader.onloadend = () => {
        setPlanImagePreview(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  // Remove image
  const handleRemoveImage = () => {
    setPlanImage(null)
    setPlanImagePreview("")
  }

  // upload img api call function.
  const callApi = async (imgBuffer) => {
    let apiData;
    const data = imgBuffer;
    await axios
      .post(
        `${API_CONSTANTS.BASEURL}admin/image-upload-api/user/${responseState.pId}/type/new`,
        data,
        {
          headers: API_CONSTANTS.imgheaders(),
        }
      )
      .then((r) => {
        apiData = r.data.response.url;
      })
      .catch((e) => {
        console.error(' [IMAGE UPLOAD ERROR]', e.response?.data || e.message);
      });
    return apiData;
  };

  const [validDurationSpan, setValidDurationSpan] = useState(responseState?.validDurationSpan || "")
  const [planCategory, setPlanCategory] = useState(responseState?.planCategory || "")
  // const [planType, setPlanType] = useState(responseState?.planType || "")
  const [specializationRows, setSpecializationRows] = useState(responseState?.specializations || [])
  
  const initialValues = {
    planStatus: responseState?.planStatus || "active",
    termsAndConditions: responseState?.termsAndConditions || "",
    charges: responseState?.charges || "",
    subscriptionName: responseState?.subscriptionName || "",
    subHeading: responseState?.sub_heading || "",
    validDuration: responseState?.validDuration || "",
    saveRupees: responseState?.saveRupees || "",
  };
  // Velidation Of Form
  const validationSchema = Yup.object({
    planStatus: Yup.string().required('Plan status is required'),
    termsAndConditions: Yup.string().required('Terms and conditions are required'),
    charges: Yup.number().min(1, 'Charges must be greater than 0').required('Charges are required'),
    subscriptionName: Yup.string().required('Subscription name is required'),
    subHeading: Yup.string().required('Sub heading is required'),
    validDuration: Yup.number().min(1, 'Valid duration must be greater than 0').required('Valid duration is required'),
    saveRupees: Yup.number().required('Save rupees value is required'),
  })
  // API Integeration 
  const handleSubmit = async (values, { setSubmitting }) => {
    setIsLoading(true)
    
    // Transform specializations to new format
    // const transformedSpecializations = specializationRows.map(spec => ({
    //   name: spec.name || spec.id,
    //   type: spec.type || spec.subscriptionPlan,
    //   calls: spec.calls !== undefined ? spec.calls : (spec.subscriptionPlan === 'no_of_calls' ? spec.noOfCalls : 'unlimited'),
    //   discount: spec.discount || null
    // }));

    const transformedSpecializations = specializationRows
  .map(spec => {
    if (spec.type === 'unlimited') {
      return {
        name: spec.name,
        type: 'unlimited',
        calls: 'unlimited',
        discount: null
      }
    }

    if (spec.type === 'discount') {
      return {
        name: spec.name,
        type: 'discount',
        calls: null,
        discount: Number(spec.discount) || 0
      }
    }

    if (spec.type === 'calls') {
      return {
        name: spec.name,
        type: 'calls',
        calls: String(spec.calls || '0'),
        discount: null
      }
    }

    return null
  })
  .filter(Boolean)


    const submitData = {
      subscriptionName: values.subscriptionName,
      sub_heading: values.subHeading,
      saveRupees: parseFloat(values.saveRupees),
      charges: parseFloat(values.charges),
      specializations: transformedSpecializations,
      validDuration: parseInt(values.validDuration),
      validDurationSpan: validDurationSpan,
      // planType: planType,
      planCategory: planCategory,
      planStatus: values.planStatus,
      includes: includes,
      termsAndConditions: values.termsAndConditions,
      url: responseState?.url || "", // Start with existing URL
      // print('submitData', submitData);
    }
      // print('submitData', submitData);
      //console.log('Submitting data:', submitData);
    
    // If there's a new image, upload it first
    if (planImage) {
      console.log(' [IMAGE] New image selected for edit:', planImage.name);
      
      try {
        const reader = new FileReader();
        
        reader.onload = async () => {
          try {
            const fileRes = btoa(reader.result);
            const testImg = toArrayBuffer(fileRes);
            
            console.log(' [API CALL] Calling image upload API...');
            let imgURL = await callApi(testImg);
            console.log(' [IMAGE URL] Received image URL:', imgURL);
            
            submitData.url = imgURL; // Update URL with uploaded image
            
            // Now send the complete JSON with image
            sendUpdateRequest(submitData, setSubmitting);
          } catch (imageError) {
            console.error(' [IMAGE ERROR]', imageError);
            handleToast(
              'Error processing image',
              faTimesCircle,
              '#dc3545',
              'show-error'
            );
            setIsLoading(false);
            setSubmitting(false);
          }
        };
        
        reader.onerror = (error) => {
          console.error(' [READER ERROR]', error);
          handleToast(
            'Error reading image file',
            faTimesCircle,
            '#dc3545',
            'show-error'
          );
          setIsLoading(false);
          setSubmitting(false);
        };
        
        console.log(' [IMAGE] Starting binary string read...');
        reader.readAsBinaryString(planImage);
      } catch (error) {
        console.error(' [IMAGE PROCESSING ERROR]', error);
        handleToast(
          'Error preparing image',
          faTimesCircle,
          '#dc3545',
          'show-error'
        );
        setIsLoading(false);
        setSubmitting(false);
      }
    } else {
      // No new image, send update directly
      sendUpdateRequest(submitData, setSubmitting);
    }
  }

  // Separate function to send the update request
  const sendUpdateRequest = (data, setSubmitting) => {
    axios.patch(
      `${API_CONSTANTS.BASEURL_1}admin/subscriptionplan/${responseState.pId}`,
      data,
      {
        headers: API_CONSTANTS.headers(),
      }
    )
      .then(response => {
        if (response.data.message === 'Success') {
          handleToast(
            'Subscription Plan Update Successfully',
            faCheckCircle,
            '#009b94',
            'show-success'
          )
        }
        UserPlanList()
        handleClose()
      })
      .catch((error) => {
        //console.error('❌ [API ERROR]', error.response?.data || error.message);
        handleToast(
          'Error updating subscription plan',
          faTimesCircle,
          '#dc3545',
          'show-error'
        );
      })
      .finally(() => {
        setIsLoading(false)
        setSubmitting(false)
      })
  }
  return (
    <>
      <button className='btn' onClick={handleShow}>
        <i className='fas fa-pen' style={{ color: '#8E8E8E' }}></i>
      </button>
      <Modal show={show} size="lg">
        <Modal.Body className="d-flex flex-column">
          <div className='d-flex justify-content-between'>
            <h4>Edit Subscription Plan</h4>
            <CloseIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
          </div>
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            <Form className="form-inline row g-3">
              <div className="col-md-6 mb-4">
                <Field
                  type="text"
                  name="subscriptionName"
                  placeholder="Plan Name"
                  className="form-control border-0 border-bottom"
                />
                <ErrorMessage name="subscriptionName" component="div" className="error-message" />
              </div>
              <div className="col-md-6 mb-4">
                <Field
                  type="text"
                  name="subHeading"
                  placeholder="Sub Heading (Short Description)"
                  className="form-control border-0 border-bottom"
                />
                <ErrorMessage name="subHeading" component="div" className="error-message" />
              </div>
              <div className="col-md-6">
                <Field
                  type="number"
                  name="saveRupees"
                  placeholder="Save Rupees"
                  className="form-control border-0 border-bottom"
                />
                <ErrorMessage name="saveRupees" component="div" className="error-message" />
              </div>
              <div className="col-md-6">
                <Field
                  type="number"
                  name="charges"
                  placeholder="Price In Rupees"
                  className="form-control border-0 border-bottom"
                />
                <ErrorMessage name="charges" component="div" className="error-message" />
              </div>

              {/* Plan Image Upload Section */}
              <div className="col-md-12 mt-4">
                <label className="form-label" style={{
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  Plan Image
                </label>
                <div className="image-upload-container">
                  <input
                    type="file"
                    id="planImageInput"
                    accept="image/*"
                    onChange={handleImageUpload}
                    style={{ display: 'none' }}
                  />
                  {!planImagePreview ? (
                    <label htmlFor="planImageInput" className="upload-label">
                      <div className="upload-box">
                        <i className="fas fa-cloud-upload-alt upload-icon"></i>
                        <p className="upload-text">Click to upload image</p>
                        <p className="upload-subtext">PNG, JPG, JPEG (Max 5MB)</p>
                      </div>
                    </label>
                  ) : (
                    <div className="image-preview-container">
                      <img src={planImagePreview} alt="Plan preview" className="preview-image" />
                      <div className="image-info">
                        <p className="image-name">
                          <i className="fas fa-image"></i> {planImage?.name || 'Current Image'}
                        </p>
                        <button
                          type="button"
                          className="btn btn-sm btn-remove-image"
                          onClick={handleRemoveImage}
                        >
                          <i className="fas fa-times"></i> Remove
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Specialization Selection Section */}
              <div className="col-md-12 mt-4">
                <label className="form-label" style={{
                  marginTop: '10px',
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  Select Specializations
                </label>
                <div className="position-relative">
                  <select
                    className="form-control border-0 border-bottom"
                    value={selectedSpecialization}
                    onChange={(e) => {
                      const specId = e.target.value;
                      if (specId && !specializationRows.find(row => row.name === specId)) {
                        setSpecializationRows([
                          ...specializationRows,
                          {
                            name: specId,
                            type: '',
                            calls: 'unlimited',
                            discount: null
                          }
                        ])
                        setSelectedSpecialization("")
                      }
                    }}
                  >
                    <option value="">Choose Specialization</option>
                    {value && value.Specializations && value.Specializations.length > 0
                      ? value.Specializations
                          .filter((s) => !specializationRows.find(row => row.name === s.Id))
                          .map((s) => (
                            <option key={s.Id} value={s.Id}>
                              {s.Id}
                            </option>
                          ))
                      : <option disabled>Loading specializations...</option>
                    }
                  </select>
                  <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-absolute" />
                </div>
              </div>

              {/* Dynamic Specialization Rows */}
              {specializationRows.length > 0 && (
                <div className="col-md-12 mt-3">
                  <label className="form-label" style={{
                    fontSize: '1rem',
                    fontWeight: '500',
                    marginBottom: '15px'
                  }}>
                    Specialization Prices
                  </label>
                  {specializationRows.map((row) => (
                    <div key={row.name} className="mb-3 specialization-row">
                      <div className="row align-items-center">
                        <div className="col-md-3">
                          <div className="spec-label">{row.name}</div>
                        </div>
                        <div className="col-md-7 position-relative">
                          <select
                            className="form-control border-0 border-bottom"
                            value={row.type}
                            onChange={(e) => {
                              setSpecializationRows(specializationRows.map(spec =>
                                spec.name === row.name ? { ...spec, type: e.target.value } : spec
                              ))
                            }}
                          >
                            <option value="">Select Plan</option>
                            <option value="unlimited">Unlimited</option>
                            <option value="discount">Discount</option>
                            <option value="calls">No of Calls</option>
                          </select>
                          <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-absolute" />
                        </div>
                        <div className="col-md-2 text-end">
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => setSpecializationRows(specializationRows.filter(spec => spec.name !== row.name))}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </div>
                      </div>
                      
                      {/* Conditional Fields based on Plan Selection */}
                      {row.type === 'discount' && (
                        <div className="row mt-3">
                          <div className="col-md-3"></div>
                          <div className="col-md-9">
                            <input
                              type="number"
                              className="form-control border-0 border-bottom"
                              placeholder="Discount Percentage (1-100)"
                              value={row.discount || ''}
                              onChange={(e) => {
                                setSpecializationRows(specializationRows.map(spec =>
                                  spec.name === row.name ? { ...spec, discount: parseFloat(e.target.value) } : spec
                                ))
                              }}
                            />
                          </div>
                        </div>
                      )}
                      
                      {row.type === 'calls' && (
                        <div className="row mt-3">
                          <div className="col-md-3"></div>
                          <div className="col-md-9">
                            <input
                              type="number"
                              className="form-control border-0 border-bottom"
                              placeholder="Number of Calls"
                              value={row.calls === 'unlimited' ? '' : row.calls}
                              onChange={(e) => {
                                setSpecializationRows(specializationRows.map(spec =>
                                  spec.name === row.name ? { ...spec, calls: e.target.value } : spec
                                ))
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              <p style={{
                marginBottom: '0px',
                marginTop: '20px',
                fontSize: '1rem',
                fontWeight: '500'
              }}>
                Duration
              </p>
              <div className="col-md-6 mb-4">
                <Field
                  type="number"
                  name="validDuration"
                  placeholder="Duration in Number"
                  className="form-control border-0 border-bottom"
                />
                <ErrorMessage name="validDuration" component="div" className="error-message" />
              </div>
              <div className="col-md-6 position-relative">
                <select
                  className="form-control border-0 border-bottom"
                  value={validDurationSpan}
                  onChange={(e) => setValidDurationSpan(e.target.value)}
                >
                  <option value="">Choose One Duration</option>
                  <option value="weeks">Weeks</option>
                  <option value="days">Days</option>
                  <option value="months">Months</option>
                  <option value="years">Yearly</option>
                </select>
                <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-absolute" />
              </div>
              {/* <div className="col-md-6 position-relative">
                <select
                  className="form-control border-0 border-bottom"
                  value={planType}
                  onChange={(e) => setPlanType(e.target.value)}
                >
                  <option value="">Select Plan Type</option>
                  <option value="individual">Individual</option>
                  <option value="family">Family</option>
                </select>
                <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-absolute" />
              </div> */}
              <div className="col-md-6 position-relative">
                <select
                  className="form-control border-0 border-bottom"
                  value={planCategory}
                  onChange={(e) => setPlanCategory(e.target.value)}
                >
                  <option value="">Choose Plan Category</option>
                   <option value="Weekly">Weekly</option>
                  <option value="2 weeks">2 Weeks</option>
                  <option value="3 weeks">3 Weeks</option>
                  <option value="Monthly">Monthly</option>
                  <option value="3 months">3 Months</option>
                  <option value="6 months">6 Months</option>
                  <option value="Yearly">Yearly</option>
                </select>
                <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon-absolute" />
              </div>

              <div className="col-md-12 mt-3">
                <label className="form-label" style={{
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  What It Includes
                </label>
                <ReactTagInput
                  tags={includes.length < 1 ? [] : includes}
                  placeholder={`Hit Enter to type the next lines`}
                  editable={true}
                  name='includes'
                  value={includes}
                  removeOnBackspace={true}
                  onChange={(e) => {
                    setIncludes(e)
                  }}
                  validateOnChange={true}
                />
              </div>
              <div className="col-md-12">
                <label className="form-label" style={{
                  fontSize: '1rem',
                  fontWeight: '500'
                }}>
                  Terms and Conditions
                </label>
                <Field
                  type="text"
                  name="termsAndConditions"
                  placeholder="All Terms and Conditions here"
                  className="form-control"
                  as="textarea"
                />
                <ErrorMessage name="termsAndConditions" component="div" className="error-message" />
              </div>
              <div className="row d-flex justify-content-center mt-5 mb-3 gap-3">
                <div className="col-md-5">
                  <button type="submit" className="btn btn-save w-100">
                    Save Changes {isLoading && <Spinner animation='border' size='sm' />}
                  </button>
                </div>
                <div className="col-md-5">
                  <button type="button" className="btn btn-outline-danger w-100" onClick={handleClose} style={{ height: '43px' }}>
                    Discard Changes
                  </button>
                </div>
              </div>
            </Form>
          </Formik>
          </Formik>
        </Modal.Body>
      </Modal>
      <style jsx='true'>
        {`
          .btn-save:hover {
            background: #009b94 !important;
            color: #fff;
          }
          .btn-discard {
            background: none;
            color: red;
            padding: 10px 10px !important;
          }
          .error-message {
            color: red;
            font-size: 0.875rem;
            margin-top: 5px;
          }
          .add-record {
            background: #009b94 !important;
            color: #fff;
          }
          .dropdown-icon-absolute {
            position: absolute;
            top: 50%;
            right: 15px;
            transform: translateY(-50%);
            pointer-events: none;
          }
          .specialization-row {
            background: #f8f9fa;
            padding: 15px;
            border-radius: 8px;
            border-left: 3px solid #009b94;
          }
          .spec-label {
            font-weight: 600;
            color: #009b94;
            padding: 10px 0;
            font-size: 0.95rem;
          }
          .btn-danger {
            background-color: #dc3545;
            border: none;
          }
          .btn-danger:hover {
            background-color: #c82333;
          }
          .react-tag-input:hover{
            border-color: #009b94 !important;
          }
          .react-tag-input__tag__remove{
            background: none !important;
          }
          .react-tag-input__tag__remove::before{
            background-color: #009b94 !important;
          }
          .react-tag-input__tag__remove::after{
            background-color: #009b94 !important;
          }
          .image-upload-container {
            margin-top: 10px;
          }
          .upload-label {
            cursor: pointer;
            display: block;
            margin-bottom: 0;
          }
          .upload-box {
            border: 2px dashed #009b94;
            border-radius: 8px;
            padding: 40px 20px;
            text-align: center;
            background: #f8f9fa;
            transition: all 0.3s ease;
          }
          .upload-box:hover {
            background: #e9ecef;
            border-color: #007d77;
          }
          .upload-icon {
            font-size: 3rem;
            color: #009b94;
            margin-bottom: 10px;
          }
          .upload-text {
            font-size: 1rem;
            font-weight: 500;
            color: #333;
            margin-bottom: 5px;
          }
          .upload-subtext {
            font-size: 0.875rem;
            color: #6c757d;
            margin-bottom: 0;
          }
          .image-preview-container {
            border: 2px solid #009b94;
            border-radius: 8px;
            padding: 15px;
            background: #f8f9fa;
          }
          .preview-image {
            width: 100%;
            max-height: 200px;
            object-fit: contain;
            border-radius: 5px;
            margin-bottom: 15px;
            background: white;
          }
          .image-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            gap: 10px;
          }
          .image-name {
            font-size: 0.9rem;
            color: #333;
            font-weight: 500;
            margin-bottom: 0;
            display: flex;
            align-items: center;
            gap: 8px;
          }
          .image-name i {
            color: #009b94;
          }
          .btn-remove-image {
            background-color: #dc3545;
            color: white;
            border: none;
            padding: 5px 15px;
            border-radius: 5px;
            font-size: 0.875rem;
          }
          .btn-remove-image:hover {
            background-color: #c82333;
            color: white;
          }
        `}
      </style>
      <Toast
        cName={showToast}
        icon={ToastIcon}
        color={iconColor}
        text={ToastMessage}
      />
    </>
  );
}
// Delete Function Component 
function Delete({ responseState, UserPlanList }) {
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [isLoading, setIsLoading] = useState(false)
  const [ToastMessage, setToastMessage] = useState('')
  const [showToast, setShowToast] = useState('')
  const [ToastIcon, setToastIcon] = useState(faTimesCircle)
  const [iconColor, setIconColor] = useState('')
  const handleToast = (message, icon, iconColor, className) => {
    setToastIcon(icon)
    setToastMessage(message)
    setShowToast(`show ${className}`)
    setIconColor(iconColor)
    setTimeout(() => setShowToast(''), 2900)
  }
  const handleDelete = () => {
    setIsLoading(true);
    axios
      .delete(`${API_CONSTANTS.BASEURL_1}admin/subscriptionplan/${responseState.pId}`,
        {
          headers: API_CONSTANTS.headers(),
        })
      .then((response) => {
        if (response.data.message === 'Success') {
          handleToast(
            'Subscription Plan Deleted Successfully',
            faCheckCircle,
            '#009b94',
            'show-success'
          )
        }
        setIsLoading(false)
        UserPlanList()
        setShow(false)
      })
  }
  return (
    <>
      <button className='btn' onClick={handleShow}>
        <i className='fas fa-trash-alt' style={{ color: '#FF6760' }}></i>
      </button>
      <Modal show={show}
        className='d-flex justify-content-center align-items-center'
      >
        <Modal.Body className='d-flex justify-content-around align-items-center flex-column' style={{ maxHeight: '255px' }}>
          <div style={{
            width: '32px',
            height: '32px'
          }}>
            <img src={PDelete} alt='' />
          </div>
          <h4 style={{ color: '#AF1300' }}>Delete !</h4>
          <p style={{ textAlign: 'center' }}>Are you sure you want to Delete this subscription Plan?</p>
          <div className='d-flex' style={{ gap: '20px' }}>
            <Button style={{ color: '#FFFFFF', backgroundColor: '#B00020', border: 'none' }} onClick={handleDelete}>
              Delete {isLoading && <Spinner animation='border' size='sm' />}
            </Button>
            <Button
              style={{ color: '#4A4A4A', backgroundColor: '#FFFFFF', border: '1px solid #4A4A4A' }}
              onClick={() => handleClose()}
            >
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      <Toast
        cName={showToast}
        icon={ToastIcon}
        color={iconColor}
        text={ToastMessage}
      />
    </>
  )
}

// Edit And Delete Component Call Component 
function ActionButtons({ responseState, userPlanList }) {
  return (
    <div style={{ width: "125px" }} className='d-flex'>
      <Edit responseState={responseState} UserPlanList={userPlanList} />
      <Delete responseState={responseState} UserPlanList={userPlanList} />
    </div>
  )
}
// SubScription List Component
export default function SubscriptionUserList() {
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState('')
  const [planList, setPlanList] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [pageCount, setPageCount] = useState(0)
  const fetchIdRef = React.useRef(0)
  //Filters
  const filter_status = {
    status: useSelector((state) => state.nurseFilterReducer.value),
    gender: useSelector((state) => state.nurseFilterReducer.value1),
    // age: useSelector((state) => state.nurseFilterReducer.value2),
    created_at: useSelector((state) => state.nurseFilterReducer.value2),
  }

  //
  const fetchData = React.useCallback(
    ({ pageSize, pageIndex }) => {
      const fetchId = lastEvaluatedKey
      if (fetchId === fetchIdRef.current) {
        const startRow = pageSize * pageIndex
        const endRow = startRow + pageSize
        setPlanList(planList.slice(startRow, endRow))
        setPageCount(Math.ceil(planList.length / pageSize))
      }
    },
    [planList, lastEvaluatedKey]
  )
  // Get API of Subscription Plan 
  const userPlanList = () => {
    axios
      .get(
        `${API_CONSTANTS.BASEURL_1}admin/subscriptionplan`,
        {
          headers: API_CONSTANTS.headers(),
        }
      )
      .then((res) => {
        setIsLoading(true)
        setLastEvaluatedKey(res.data.response.Items[0].LastEvaluatedKey)
        setPlanList(res.data.response?.Items[0]?.list)
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          window.location.reload()
          window.localStorage.clear()
        }
        setIsLoading(true)
        setPlanList([])
      })
  }
  // const [page, setPage] = useState(0)

  // const handleLoadMoreData = () => {
  //   axios
  //     .get(
  //       `${API_CONSTANTS.BASEURL_1}admin/nurses?last=${lastEvaluatedKey}`,
  //       {
  //         headers: API_CONSTANTS.headers(),
  //       }
  //     )
  //     .then((response) => {
  //       setLastEvaluatedKey(response.data.response.LastEvaluatedKey)
  //       var nurseListNextPage = response.data.response.Items
  //       setNurseList([...nurseList, ...nurseListNextPage])
  //       setPage(page + 1)
  //     })
  //     .then(() => setLoading(true))
  // }
  const columns = useMemo(
    () => [
      {
        Header: 'Subscription Name',
        accessor: (data) => data.subscriptionName || 'No Name',
      },
      {
        Header: 'No. Of Calls',
        accessor: 'noOfCalls',
      },
      {
        Header: 'Duration',
        accessor: 'validDuration',
      },
      {
        Header: 'Price in Rupee',
        accessor: 'charges',
      },
      {
        Header: 'Status',
        // accessor: 'planStatus',
        accessor: (responseState) => <Status responseState={responseState} />
      },
      {
        Header: ' ',
        accessor: (responseState) => <ActionButtons responseState={responseState} userPlanList={userPlanList} />,
      },
    ],
    []
  )
  const is_SessionExpire = () => {
    window.localStorage.clear()
    window.location.reload()
  }
  useEffect(() => {
    userPlanList()
  }, [
    filter_status.created_at,
    filter_status.gender,
    filter_status.status,
  ])
  // Table rendering
  if (error) {
    return (
      <AlertMessage
        errorMessage={
          error.message === 'Request failed with status code 401'
            ? is_SessionExpire()
            : error.message === 'Request failed with status code 404'
              ? 'record not found'
              : error.message
        } />
    )
  } else if (!isLoading) {
    return (
      <div className='d-flex justify-content-center  '>
        <Spinner animation='border' style={{ color: '#24AAA4' }} />
      </div>
    )
  } else {
    return (
      <>
        <div className='row rounded bg-white m-4'>
          <div>
            <h3
              style={{ fontSize: '16px', fontWeight: '500', padding: '18px' }}
            >
              All Subscription Plans
            </h3>
          </div>
          <Table
            // pageNumber={page}
            columns={columns}
            data={planList}
            routingLink={''}
            pageCount={pageCount}
            fetchData={fetchData}
            // loadMoreList={handleLoadMoreData}
            lastEvaluatedKey={lastEvaluatedKey}
            loading={loading}
            setLoading={setLoading}
          // FilterForm={<NurseFilterForm nurseList={userList} />}
          />
        </div>
        <style jsx='true'>{`
          .btn:focus {
            box-shadow: 0 0 0 0.25rem rgb(0 155 148 / 25%) !important;
          }
          input::-webkit-outer-spin-button,
          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
          .patient-search-input {
            border-radius: 0;
          }
        `}</style>

      </>
    )
  }
}